import { Spinner, Text, TextAlignment, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import React from 'react';
import { COLOR_TOKEN } from '../../constants/styles-constants';
import { isLayerForm } from '../../helpers/form-helpers';
import { Section } from './section';

interface Props {
	text?: string;
	color?: string;
	spinner?: 'default' | 'large';
}

const LoadingContent = (props: Props) => {
	const { text, spinner } = props;

	return (
		<>
			<Spinner variant={spinner ? spinner : 'default'} />
			<Text appearance={TokenTextAppearance.copy100} textAlign={TextAlignment.center}>
				{text ? text : 'Cargando...'}
			</Text>
		</>
	);
};
interface ScreenProps {
	text?: string;
}

export const LoadingScreen = (props: ScreenProps) => {
	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'center',
				alignItems: 'center',
				height: '100vh',
				position: isLayerForm() ? 'absolute' : 'fixed',
				left: '0',
				right: '0',
				top: '0',
				bottom: '0',
				background: COLOR_TOKEN.background.primary,
				zIndex: '1',
			}}
		>
			<LoadingContent {...props} spinner="large" />
		</div>
	);
};

interface SectionProps {
	text?: string;
	align?: string;
	height?: string;
}

export const LoadingSection = (props: SectionProps) => {
	const { align, height } = props;
	return (
		<Section>
			<div
				style={{
					display: 'flex',
					flexDirection: 'row',
					justifyContent: align ? align : 'center',
					alignItems: 'center',
					height: height ? height : 'auto',
				}}
			>
				<LoadingContent {...props} />
			</div>
		</Section>
	);
};

export const LoadingIcon = () => <Spinner variant="large" />;
